// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--27elc typography-module--base--3b7o6"};